export default {
      id: "ic-plan-ports-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-ports-usage",
      toString: function () {
        return this.url;
      }
    }